// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentFeeSettingsFieldsFragment = { __typename?: 'PaymentFeeSettings', id: string, entity_id: string, entity_type: Types.PaymentFeeSettingsEntityType, website_rate: number, marketplace_quote_rate: number, standard_quote_rate: number, widget_rate: number, dashboard_rate: number, is_overriding: boolean };

export type UpsertPaymentFeeSettingsMutationVariables = Types.Exact<{
  data: Types.UpsertPaymentFeeSettingsInput;
}>;


export type UpsertPaymentFeeSettingsMutation = { __typename?: 'Mutation', upsertPaymentFeeSettings: { __typename?: 'PaymentFeeSettings', id: string, entity_id: string, entity_type: Types.PaymentFeeSettingsEntityType, website_rate: number, marketplace_quote_rate: number, standard_quote_rate: number, widget_rate: number, dashboard_rate: number, is_overriding: boolean } };

export type DeletePaymentFeeSettingsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeletePaymentFeeSettingsMutation = { __typename?: 'Mutation', deletePaymentFeeSettings?: any | null };

export const PaymentFeeSettingsFieldsFragmentDoc = gql`
    fragment PaymentFeeSettingsFields on PaymentFeeSettings {
  id
  entity_id
  entity_type
  website_rate
  marketplace_quote_rate
  standard_quote_rate
  widget_rate
  dashboard_rate
  is_overriding
}
    `;
export const UpsertPaymentFeeSettingsDocument = gql`
    mutation upsertPaymentFeeSettings($data: UpsertPaymentFeeSettingsInput!) {
  upsertPaymentFeeSettings(data: $data) {
    ...PaymentFeeSettingsFields
  }
}
    ${PaymentFeeSettingsFieldsFragmentDoc}`;
export type UpsertPaymentFeeSettingsMutationFn = Apollo.MutationFunction<UpsertPaymentFeeSettingsMutation, UpsertPaymentFeeSettingsMutationVariables>;

/**
 * __useUpsertPaymentFeeSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertPaymentFeeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaymentFeeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaymentFeeSettingsMutation, { data, loading, error }] = useUpsertPaymentFeeSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertPaymentFeeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaymentFeeSettingsMutation, UpsertPaymentFeeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaymentFeeSettingsMutation, UpsertPaymentFeeSettingsMutationVariables>(UpsertPaymentFeeSettingsDocument, options);
      }
export type UpsertPaymentFeeSettingsMutationHookResult = ReturnType<typeof useUpsertPaymentFeeSettingsMutation>;
export type UpsertPaymentFeeSettingsMutationResult = Apollo.MutationResult<UpsertPaymentFeeSettingsMutation>;
export type UpsertPaymentFeeSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertPaymentFeeSettingsMutation, UpsertPaymentFeeSettingsMutationVariables>;
export const DeletePaymentFeeSettingsDocument = gql`
    mutation deletePaymentFeeSettings($id: ID!) {
  deletePaymentFeeSettings(id: $id)
}
    `;
export type DeletePaymentFeeSettingsMutationFn = Apollo.MutationFunction<DeletePaymentFeeSettingsMutation, DeletePaymentFeeSettingsMutationVariables>;

/**
 * __useDeletePaymentFeeSettingsMutation__
 *
 * To run a mutation, you first call `useDeletePaymentFeeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentFeeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentFeeSettingsMutation, { data, loading, error }] = useDeletePaymentFeeSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentFeeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentFeeSettingsMutation, DeletePaymentFeeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentFeeSettingsMutation, DeletePaymentFeeSettingsMutationVariables>(DeletePaymentFeeSettingsDocument, options);
      }
export type DeletePaymentFeeSettingsMutationHookResult = ReturnType<typeof useDeletePaymentFeeSettingsMutation>;
export type DeletePaymentFeeSettingsMutationResult = Apollo.MutationResult<DeletePaymentFeeSettingsMutation>;
export type DeletePaymentFeeSettingsMutationOptions = Apollo.BaseMutationOptions<DeletePaymentFeeSettingsMutation, DeletePaymentFeeSettingsMutationVariables>;